@use 'sass:meta';
@use 'sass:color';
@use '@/sass/variables';
@include meta.load-css('@/sass/tachyons/containers.scss');

.dropdown {
  display: inline-block;
}

.dropdown-toggle {
  display: inline-block;
  cursor: pointer;
}

.dropdown-menu {
  @extend .ui-card;

  [data-arrow-align] {
    width: 0;
    height: 0;
    z-index: 20;
    pointer-events: none;
    border-left: 12px solid transparent;
    border-right: 12px solid transparent;
    &:after,
    &:before {
      content: '';
      position: absolute;
      border-left: 12px solid transparent;
      border-right: 12px solid transparent;
    }
    &:before {
      z-index: 21;
    }
    &:after {
      z-index: 20;
    }
  }

  [data-arrow-align='top-left'] {
    &:before {
      top: -12px;
      left: 0;
      border-bottom: 12px solid variables.$white;
    }
    &:after {
      top: -13px;
      left: 0;
      border-bottom: 12px solid variables.$gray;
    }
  }
  [data-arrow-align='top-center'] {
    &:before {
      left: 50%;
      transform: translate(-50%, 0);
      top: -12px;
      border-bottom: 12px solid variables.$white;
    }
    &:after {
      left: 50%;
      transform: translate(-50%, 0);
      top: -13px;
      border-bottom: 12px solid variables.$gray;
    }
  }
  [data-arrow-align='top-right'] {
    &:before {
      top: -12px;
      right: 0;
      border-bottom: 12px solid variables.$white;
    }
    &:after {
      top: -13px;
      right: 0;
      border-bottom: 12px solid variables.$gray;
    }
  }

  [data-arrow-align='bottom-left'] {
    &:before {
      bottom: -12px;
      left: 0;
      border-top: 12px solid variables.$white;
    }
    &:after {
      bottom: -13px;
      left: 0;
      border-top: 12px solid variables.$gray;
    }
  }
  [data-arrow-align='bottom-center'] {
    &:before {
      left: 50%;
      transform: translate(-50%, 0);
      bottom: -12px;
      border-top: 12px solid variables.$white;
    }
    &:after {
      left: 50%;
      transform: translate(-50%, 0);
      bottom: -13px;
      border-top: 12px solid variables.$gray;
    }
  }
  [data-arrow-align='bottom-right'] {
    &:before {
      right: 0;
      bottom: -12px;
      border-top: 12px solid variables.$white;
    }
    &:after {
      right: 0;
      bottom: -13px;
      border-top: 12px solid variables.$gray;
    }
  }
}

.dropdown-menu-item {
  font-size: variables.$font-size-6;
  color: variables.$near-black;
  line-height: variables.$line-height-solid;
  padding: variables.$spacing-small;
  min-width: 6rem;
  cursor: pointer;
  white-space: nowrap;
  &:first-child {
    padding-top: variables.$spacing-medium;
  }
  &:last-child {
    border-radius: 0 0 2px 2px;
  }
  &:hover {
    background-color: variables.$near-white;
  }
  &:active,
  &.dropdown-menu-item--highlighted {
    background-color: color.adjust(variables.$near-white, $lightness: -5%, $space: hsl);
  }
}

.dropdown-menu-divider {
  width: 100%;
  height: 1px;
  background-color: variables.$moon-gray;
}

.dropdown-menu-wrapper {
  background: variables.$white;
}
